import { z } from 'zod';

export const paymentTermsTypes = {
  PAY_NOW: 'pay_now',
  DEFERRED_FULL: 'deferred_full',
  DEFERRED_PARTIAL: 'deferred_partial',
} as const;

const PaymentTermsTypeSchema = z.enum([
  paymentTermsTypes.PAY_NOW,
  paymentTermsTypes.DEFERRED_FULL,
  paymentTermsTypes.DEFERRED_PARTIAL,
]);

const RawPaymentTermsSchema = z.object({
  type: PaymentTermsTypeSchema,
  amount_due_now: z.object({ amount: z.number(), currency_code: z.string().nullable() }).nullish(),
  balance_due_date: z.string().nullish(),
  deposit_only: z.boolean().nullish(),
});

const PaymentTermsSchema = z.object({
  type: PaymentTermsTypeSchema,
  amountDueNow: z.object({ amount: z.number(), currencyCode: z.string().nullable() }).nullish(),
  balanceDueDate: z.string().nullish(),
  depositOnly: z.boolean().nullish(),
});

/**
 * Payment terms are presentational, so a payload the schema does not recognise degrades to
 * no badge rather than failing the parse and taking the whole listing down with it.
 */
export const OptionalRawPaymentTermsSchema = RawPaymentTermsSchema.nullish().catch(null);
export const OptionalPaymentTermsSchema = PaymentTermsSchema.nullish().catch(null);
